import { useEffect } from "react";
import styles from "./WizardShell.module.css";
import clsx from "clsx";

// compose class names; falsy values are skipped
// const cx = (...xs) => xs.filter(Boolean).join(" ");

export default function WizardShell({
  isOpen,
  trayVh,                 // number (e.g. 50)
  onClose,                // () => void
  onStartDrag,            // (clientY:number) => void
  onDragMove,             // not used here (parent already wires global listeners)
  onEndDrag,              // not used here (parent already wires global listeners)
  tab,                    // "drafts" | "summary"
  onTabChange,            // (t) => void
  children,               // the Drafts/Summary body + any footers you pass
  tabs = ["drafts","summary"] // default two tabs for non-admin
}) {
  // Esc to close (outside clicks should NOT close)
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <aside
      id="reassign-bottom-tray"
      className={styles["ab-bottom-tray"]}
      role="complementary"
      aria-labelledby="reassign-title"
      style={{ height: `${trayVh}vh` }}
    >
      {/* draggable bumper (keeps your existing styles) */}
      <div
        className={styles["ab-tray-resize"]}
        role="separator"
        aria-orientation="horizontal"
        aria-label="Resize reassignment panel"
        title="Drag to resize"
        tabIndex={0}
        onMouseDown={(e) => onStartDrag?.(e.clientY)}
        onTouchStart={(e) => onStartDrag?.(e.touches?.[0]?.clientY)}
      >
        <div className={styles["bumper"]}>
          <span className="bumper-grip" aria-hidden="true" />
        </div>
      </div>

      {/* header with your inline tabs, size, and close button */}
      <header className={clsx(
          styles["ab-tray-header"],
          styles["ab-tray-header--merged"]
        )}
        aria-label="Reassignment Wizard"
      >
        <div className={styles["ath-left"]}>
          <h3 id="reassign-title" tabIndex={-1}>Reassignment Wizard</h3>

          <div className={clsx(styles["wiz-tabs"], styles["wiz-tabs--inline"])} role="tablist" aria-label="Wizard steps">
            {tabs.map(t => (
             <button
               key={t}
               role="tab"
               aria-selected={tab === t}
               className={clsx(styles["wiz-tab"], tab === t && styles.active)}
               onClick={() => onTabChange?.(t)}
                              >
                {t === "drafts" ? "Drafts" : t === "summary" ? "Summary" : "Pending"}
             </button>
            ))}
          </div>

          {/* <div className={clsx(styles["wiz-tabs"], styles["wiz-tabs--inline"])} role="tablist" aria-label="Wizard steps">
            <button
              role="tab"
              aria-selected={tab === "drafts"}
              className={clsx(
                styles["wiz-tab"],
                tab === "drafts" && styles.active
              )}
              onClick={() => onTabChange?.("drafts")}
            >
              Drafts
            </button>
            <button
              role="tab"
              aria-selected={tab === "summary"}
              className={clsx(
                styles["wiz-tab"],
                tab === "summary" && styles.active
              )}
              onClick={() => onTabChange?.("summary")}
            >
              Summary
            </button>
          </div> */}
        </div>

        <div className={styles["ab-tray-actions"]}>
          <span className={styles["ab-tray-size"]}>{Math.round(trayVh)}% height</span>
          <button
            type="button"
            className={styles["mint-close-btn"]}
            onClick={onClose}
            aria-label="Close"
            title="Close"
          >
            ×
          </button>
        </div>
      </header>

      {/* body */}
      <div className={styles["ab-tray-content"]}>{children}</div>
    </aside>
  );
}
